'use strict';
const gallery = [...document.querySelectorAll('.thumbnail')];
const mainImage = document.querySelector('#main-image');
function selectImage(index) {
  const selected = gallery[index];
  mainImage.src = selected.dataset.image;
  mainImage.alt = selected.dataset.alt;
  mainImage.onload = () => { if (innerWidth <= 700) mainImage.parentElement.style.aspectRatio = `${mainImage.naturalWidth} / ${mainImage.naturalHeight}`; };
  gallery.forEach((button, i) => {button.classList.toggle('active', i === index);button.setAttribute('aria-pressed', String(i === index));});
  document.querySelector('.image-count').textContent = `${String(index + 1).padStart(2,'0')} / ${String(gallery.length).padStart(2,'0')}`;
}
gallery.forEach((button, index) => {
  button.addEventListener('click', () => selectImage(index));
  button.addEventListener('keydown', event => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? gallery.length-1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + gallery.length) % gallery.length;
    selectImage(next);gallery[next].focus();
  });
});
const menuButton = document.querySelector('.menu-button');
const mobileNav = document.querySelector('#mobile-nav');
function closeMenu() {mobileNav.hidden=true;menuButton.setAttribute('aria-expanded','false');menuButton.querySelector('.sr-only').textContent='Open navigation';}
menuButton.addEventListener('click', () => {const isOpen=menuButton.getAttribute('aria-expanded')==='true';mobileNav.hidden=isOpen;menuButton.setAttribute('aria-expanded',String(!isOpen));menuButton.querySelector('.sr-only').textContent=isOpen?'Open navigation':'Close navigation';});
mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!mobileNav.hidden){closeMenu();menuButton.focus();}});
window.matchMedia('(min-width:701px)').addEventListener('change',closeMenu);
// Shared navigation for the local website. Email forms use the existing backend.
// Announce every external destination without changing the visible footer design.
document.querySelectorAll('a[target="_blank"]').forEach(anchor=>{
  if (anchor.querySelector('.sr-only') || anchor.hasAttribute('aria-label')) return;
  const note=document.createElement('span');note.className='sr-only';
  note.textContent=' (opens in a new tab)';anchor.append(note);
});
const sticky=document.querySelector('.sticky-cta');
const heroJoin=document.querySelector('#join');
const finalJoin=document.querySelector('#join-bottom');
function updateSticky(){
 if(!sticky||!heroJoin||!finalJoin)return;
 const hero=heroJoin.getBoundingClientRect();const bottom=finalJoin.getBoundingClientRect();
 const submit = heroJoin.querySelector('.signup-link').getBoundingClientRect();
 const beforeFormOnMobile = innerWidth <= 700 && submit.bottom > innerHeight;
 sticky.hidden = !((hero.bottom < 84 || beforeFormOnMobile) && (bottom.bottom < 0 || bottom.top > innerHeight));
}
let queued=false;
window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;updateSticky();});}},{passive:true});
window.addEventListener('resize',updateSticky);updateSticky();
// Keep fragment destinations clear of the sticky header and move keyboard focus with them.
// Instant scrolling avoids racing long smooth-scroll animations with focus changes.
function goToAnchor(hash, updateHistory=true) {
 hash=({'#zv-main-ingredients':'#formula','#zvForm':'#join','#zv-join':'#join'})[hash]||hash;
 const channelOptions = hash === '#reservation-form' ? document.querySelector('[data-zv-channel-options]:not([hidden])') : null;
 const target=channelOptions || document.getElementById(hash.slice(1));
 if(!target)return;
 closeMenu();
 if(hash==='#formula'&&!target.classList.contains('receipt-section')&&document.querySelector('#full-formula'))document.querySelector('#full-formula').open=true;
 if(target.tagName==='DETAILS')target.open=true;
 if(target.matches('details[id^="source-"]'))target.querySelectorAll('details').forEach(details=>details.open=true);
 for(let parent=target.parentElement;parent;parent=parent.parentElement){if(parent.tagName==='DETAILS')parent.open=true;}
 if(updateHistory&&location.hash!==hash)history.pushState(null,'',hash);
 requestAnimationFrame(()=>{
  const offset=document.querySelector('.header').getBoundingClientRect().height+20;
  window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+scrollY-offset),behavior:'instant'});
  if(!target.matches('a,button,input,summary,[tabindex]'))target.setAttribute('tabindex','-1');
  target.focus({preventScroll:true});updateSticky();
 });
}
document.querySelectorAll('a[href*="#"]').forEach(anchor=>anchor.addEventListener('click',event=>{
 if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
 const destination = new URL(anchor.href);
 if(destination.origin !== location.origin || destination.pathname.replace(/\/$/,'') !== location.pathname.replace(/\/$/,'') || destination.search !== location.search)return;
 event.preventDefault();goToAnchor(anchor.hash);
}));
window.addEventListener('hashchange',()=>goToAnchor(location.hash,false));
if(location.hash)window.addEventListener('load',()=>document.fonts.ready.then(()=>goToAnchor(location.hash,false)));


// Touch navigation is scoped to the product image; vertical scrolling stays native.
const swipeArea = mainImage?.closest('.gallery-main');
if (swipeArea && gallery.length > 1) {
  let swipe = null;
  let suppressClickUntil = 0;
  swipeArea.addEventListener('pointerdown', event => {
    if (!event.isPrimary) { swipe = null; return; }
    if (event.pointerType !== 'touch' || !matchMedia('(max-width:700px)').matches) return;
    suppressClickUntil = 0;
    swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
  }, { passive: true });
  swipeArea.addEventListener('pointermove', event => {
    if (!swipe || event.pointerId !== swipe.id) return;
    const dx = Math.abs(event.clientX - swipe.x);
    const dy = Math.abs(event.clientY - swipe.y);
    if (dy > 10 && dy > dx) swipe = null;
  }, { passive: true });
  swipeArea.addEventListener('pointerup', event => {
    if (!swipe || event.pointerId !== swipe.id) return;
    const dx = event.clientX - swipe.x;
    const dy = event.clientY - swipe.y;
    swipe = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
    const active = Math.max(0, gallery.findIndex(button => button.classList.contains('active')));
    selectImage((active + (dx < 0 ? 1 : -1) + gallery.length) % gallery.length);
    suppressClickUntil = performance.now() + 400;
  }, { passive: true });
  swipeArea.addEventListener('pointercancel', () => { swipe = null; }, { passive: true });
  swipeArea.addEventListener('click', event => {
    if (performance.now() < suppressClickUntil) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
}

